import { forwardRef } from 'react';
import { ItemButtonProps } from '../../types';
import { Basic } from './basic';

export const Button = forwardRef<HTMLButtonElement, ItemButtonProps>(
  function Component(props, forwardedRef) {
    return <Basic type="button" {...props} rootRef={forwardedRef} />;
  }
);
